// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"24c09c72","58":"1ff75f2d","167":"ab88892e","214":"b39a97d6","348":"19ef9f0d","458":"63c52b23","577":"66801e42","652":"8d9d1ffd","682":"d5252985","783":"c66ca607","812":"a8661619","867":"cd0d99bc","904":"538f6d3c","985":"de897744","997":"f487d4a9"}[chunkId] + ".js";
};